import { useLayoutEffect } from 'react';
import { useNavigate } from 'react-router';

export function useRedirect(condition: boolean, redirectPath: string) {
    const navigate = useNavigate();

    useLayoutEffect(() => {
        if (!condition) {
            navigate(redirectPath);
        }
    }, [condition, redirectPath, navigate]);
}
